$(document).ready(function(){
    var owl = $('.ny-recipe__slider');
    owl.owlCarousel({
        autoplay: false,
        loop: false,
        nav: false,
        dots:true,
        items: 1
    });
    $('.ny-recipe__slider_item').hover(
        function(){
            $(this).find('.ny-recipe__slider_text').stop().fadeIn();
        },
        function(){
            $(this).find('.ny-recipe__slider_text').stop().fadeOut();
        });

});
